module.exports = __webpack_public_path__ + "assets/img/community.1caf8ed8.jpg";